module.exports = __webpack_public_path__ + "static/img/mcht_mini.19a7db5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/intderface/mcht_mini.png
// module id = YQQQ
// module chunks = 0